import { Rule } from 'entities/campaign';
import { Channel } from 'entities/campaign/rulesets/channels';
import { Actions as GenericActions } from './genericService';
import { Action, Types } from './types';

export const Actions = {
  ...GenericActions,
  addChannel: (rulesetId: string, channel: Channel): Action => ({
    type: Types.CHANNEL_ADDED,
    payload: { rulesetId, channel },
  }),
  addRule: (rulesetId: string, rule: Rule): Action => ({
    type: Types.RULE_ADDED,
    payload: { rulesetId, rule },
  }),
  editRule: (rulesetId: string, ruleIndex: number, changes: Rule): Action => ({
    type: Types.RULE_EDITED,
    payload: { rulesetId, ruleIndex, changes },
  }),
  deleteRule: (rulesetId: string, ruleIndex: number): Action => ({
    type: Types.RULE_DELETED,
    payload: { rulesetId, ruleIndex },
  }),
  cloneRuleset: (rulesetId: string): Action => ({
    type: Types.RULESET_CLONED,
    payload: { rulesetId },
  }),
  channelChanged: (rulesetId: string, channelIndex: number, channel: Channel): Action => ({
    type: Types.CHANNEL_CHANGED,
    payload: { rulesetId, channelIndex, channel },
  }),
  channelDeleted: (rulesetId: string, channelIndex: number, cycleId: string): Action => ({
    type: Types.CHANNEL_DELETED,
    payload: { rulesetId, channelIndex, cycleId },
  }),
};
